// Delivery timer, turn into class
const isExcludedDay = (proposedDate, excludedDay) => {

    let days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']
    let dayKey = Object.keys(days).find(key => days[key] === excludedDay.toLowerCase())
    if(proposedDate.getDay() == dayKey) {
        return true
    } 
    
    return false

}

const isExcludedDate = (proposedDate, excludedDate) => {

    let date = new Date(proposedDate.getTime())
    
    // normalise date hours/minutes/seconds/milliseconds
    date.setHours(0)
    date.setMinutes(0)
    date.setSeconds(0)
    date.setMilliseconds(0)

    // normalise excluded date hours/minutes/seconds/milliseconds
    excludedDate.setHours(0)
    excludedDate.setMinutes(0)
    excludedDate.setSeconds(0)
    excludedDate.setMilliseconds(0)
    if(date.getTime() == excludedDate.getTime()) {
        return true
    }
    
    return false

}

const cutoff = (cutoffHour, cutoffMinute, exclusionDaysDespatch, exclusionDatesDespatch, days) => {
    
    let dateNow = new Date()
    let dateCutoff = new Date(dateNow.getTime())

    // set cut off hour
    dateCutoff.setHours(cutoffHour)
    dateCutoff.setMinutes(cutoffMinute)
    dateCutoff.setSeconds(0)
    dateCutoff.setMilliseconds(0)

    // if past cutoff hour, modify cut off
    if(dateNow.getTime() > dateCutoff.getTime()) {
        dateCutoff.setDate(dateCutoff.getDate() + 1)
    }

    // if no despatch day, modify cut off
    exclusionDaysDespatch.forEach((day) => {
        if(isExcludedDay(dateCutoff, day)) {
            dateCutoff.setDate(dateCutoff.getDate() + 1)
        }
    })

    // if no despatch date, modify cut off
    exclusionDatesDespatch.forEach((dateValue) => {
        let date = new Date(Date.parse(dateValue))
        if(isExcludedDate(dateCutoff, date)) {
            dateCutoff.setDate(dateCutoff.getDate() + 1)
        }
    })

    return dateCutoff

}

const delivery = (startDate, leadTime, exclusionDaysDelivery, exclusionDatesDelivery) => {

    let dateDelivery = new Date(startDate.getTime())
    let realLeadTime = leadTime

    // first check if any leadTime days are affected by exclusions
    let lt = 1
    while(lt <= realLeadTime) {

        let dateLeadTime = new Date(startDate.getTime())
        dateLeadTime.setDate(dateLeadTime.getDate() + lt)
        let modifier = 0

        // if in excluded days, modify lead time
        exclusionDaysDelivery.forEach((day) => {
            if(isExcludedDay(dateLeadTime, day)) {
                modifier = 1
            }
        })
    
        // if in excluded dates, modify lead time
        exclusionDatesDelivery.forEach((dateValue) => {
            let date = new Date(Date.parse(dateValue))
            if(isExcludedDate(dateLeadTime, date)) {
                    modifier = 1
            }
        })

        realLeadTime = realLeadTime + modifier
        lt++
        
    }

    // set date for real lead time
    dateDelivery.setDate(dateDelivery.getDate() + realLeadTime)

    // if in excluded days, modify delivery date
    exclusionDaysDelivery.forEach((day) => {
        if(isExcludedDay(dateDelivery, day)) {
            dateDelivery.setDate(dateDelivery.getDate() + 1)
        }
    })

    // if in excluded dates, modify delivery date
    exclusionDatesDelivery.forEach((dateValue) => {
        let date = new Date(Date.parse(dateValue))
        if(isExcludedDate(dateDelivery, date)) {
                dateDelivery.setDate(dateDelivery.getDate() + 1)
        }
    })

    return dateDelivery

}

const timerDifference = (startTime, endTime) => {

    let difference = endTime - startTime
    return {
        "days": Math.floor(difference / (1000 * 60 * 60 * 24)),
        "hours": Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        "minutes": Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
        "seconds": Math.floor((difference % (1000 * 60)) / 1000)
    }

}

const timer = (settings) => {

    let days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']
    let timerContainer = document.querySelector('[data-timer-on="true"]')
    if(timerContainer == null) return
    let deliveryDayContainer = timerContainer.querySelector('.delivery-day')
    let deliveryDaysContainer = timerContainer.querySelector('.delivery-days')
    let deliveryHoursContainer = timerContainer.querySelector('.delivery-hours')
    let deliveryMinutesContainer = timerContainer.querySelector('.delivery-minutes')
    let deliverySecondsContainer = timerContainer.querySelector('.delivery-seconds')

    window.deliveryTimer = setInterval(() => {

        let cutoffDate = cutoff(settings.cutoffHour, settings.cutoffMinute, settings.exclusionDaysDespatch, settings.exclusionDatesDespatch, days);
        let deliveryDate = delivery(cutoffDate, settings.leadTime, settings.exclusionDaysDelivery, settings.exclusionDatesDelivery, days);
        let dateNow = new Date();
        let difference = timerDifference(dateNow.getTime(), cutoffDate.getTime());
        let deliveryDay = days[deliveryDate.getDay()].toUpperCase();
        deliveryDayContainer.innerHTML = deliveryDay + ' ' + deliveryDate.getDate() + getSuffix(deliveryDate.getDate());
        if(deliveryDaysContainer != null) {
            let daysSuffix = difference.days == 1 ? settings.text.singular.day : settings.text.plural.day;
            deliveryDaysContainer.innerHTML = difference.days == 0 ? '' : difference.days + ' ' + daysSuffix;
        }
        if(deliveryHoursContainer != null) {
            let hoursSuffix = difference.hours == 1 ? settings.text.singular.hour : settings.text.plural.hour;
            deliveryHoursContainer.innerHTML = difference.hours + ' ' + hoursSuffix;
        }
        if(deliveryMinutesContainer != null) {
            let minutesSuffix = difference.hours == 1 ? settings.text.singular.minute : settings.text.plural.minute;
            deliveryMinutesContainer.innerHTML = difference.minutes + ' ' + minutesSuffix;
        }
        if(deliverySecondsContainer != null) {
            let secondsSuffix = difference.seconds == 1 ? settings.text.singular.second : settings.text.plural.second;
            deliverySecondsContainer.innerHTML = difference.seconds + ' ' + secondsSuffix;
        }
    }, 1000)

}

const getSuffix = (day) => {
    let lastNum = parseInt(day.toString().slice(-1));
    switch(lastNum) {
        case 1:
            return 'st';
        case 2: 
            return 'nd';
        case 3:
            return 'rd';
        default:
            return 'th';
    }
}

window.addEventListener('DOMContentLoaded', (e) => {

    let settings = null;
    const settingsContainer = document.querySelector('[data-delivery-timer-settings]');
    console.log(settingsContainer);
    if(settingsContainer != null) {
        try {
            settings = JSON.parse(settingsContainer.textContent)
        } catch (err) {
            console.log(err)
        }
    }
    if(settings == null) {
        settings = {
            cutoffHour: 16,
            cutoffMinute: 0,
            exclusionDaysDespatch: ['Saturday', 'Sunday'],
            exclusionDatesDespatch: [],
            leadTime: 1,
            exclusionDaysDelivery: ['Saturday', 'Sunday'],
            exclusionDatesDelivery: [],
            displayWeekendMessage: false,
            weekendMessage: '',
            text: {
                singular: {
                    day: 'day',
                    hour: 'hr',
                    minute: 'min',
                    second: 'sec'
                },
                plural: {
                    day: 'days',
                    hour: 'hrs',
                    minute: 'mins',
                    second: 'secs'
                }
            }
        }
    } 

    timer(settings) 

})